import { h } from "preact";

export function AddressSuggestionsTab({ addressResults, onSelect }) {
  return (
    <div className="tab-content h-full bg-brand-100 rounded-b-md">
      <div className="max-h-[300px] overflow-y-auto p-4">
        <ul role="listbox">
          {(addressResults || []).map((result) => (
            <li
              key={
                result.id ||
                result.properties?.mapbox_id ||
                result.properties?.full_address
              }
              role="option"
            >
              <button
                type="button"
                role="link"
                onClick={() => onSelect(result)}
                className="text-left cursor-pointer p-3 block rounded text-brandcopy-500 hover:bg-white hover:text-brandcopy-900 focus:bg-white focus:text-brandcopy-900 focus:outline-brand-500 focus:outline-2 focus:outline-offset-2 w-full block"
              >
                {result.properties?.full_address ||
                  result.properties?.name ||
                  result.properties?.place_formatted}
              </button>
            </li>
          ))}
          {(!addressResults || addressResults.length === 0) && (
            <span className="alert alert--info">
              {global.Translator.trans("locationform.noresults", {}, "js")}
            </span>
          )}
        </ul>
      </div>
    </div>
  );
}
